export default __webpack_public_path__ + "static/media/ewe.fa604cf4.svg";